"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ProjectSettings = require("../ProjectSettings.styles");

var _config = require("../../../context/settings/config");

var _useActions = require("../../../context/settings/config/useActions");

const Group = (0, _styledComponents.default)(_blocks.ControlGroup)`
  justify-content: flex-end;
`;

const Foot = ({
  activeProject
}) => {
  const state = (0, _config.useConfigState)();
  const {
    resetConfig,
    saveProjectConfig
  } = (0, _useActions.useActions)();
  const handleSaveProject = React.useCallback(() => {
    void saveProjectConfig(activeProject, state.saved, state.active, state.insightType);
  }, [state.active]);
  const handleCancel = React.useCallback(() => {
    if (window.confirm("You're about to discard all unsaved changes, continue?")) {
      void resetConfig();
    }
  }, []);
  return /*#__PURE__*/React.createElement(_ProjectSettings.Foot, null, /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(_blocks.Button, {
    disabled: state.pristine || state.isSaving,
    onClick: handleCancel
  }, "Cancel"), /*#__PURE__*/React.createElement(_blocks.Button, {
    disabled: state.pristine || state.isSaving,
    onClick: handleSaveProject,
    primary: true
  }, "Save Changes")));
};

Foot.propTypes = {};
Foot.defaultProps = {};
var _default = Foot;
exports.default = _default;
module.exports = exports.default;